export default __webpack_public_path__ + "static/media/searchIcon.5fe1e77a.svg";